var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": [].concat(_vm.headers, [{
        value: 'actions',
        width: '56px'
      }]),
      "items": _vm.selectedItems,
      "disable-sort": "",
      "items-per-page": 10
    },
    scopedSlots: _vm._u([_vm._l(_vm.tableSlots, function (slot) {
      return {
        key: `item.${slot}`,
        fn: function (_ref) {
          var item = _ref.item,
            index = _ref.index;
          return [_vm._t(`item.${slot}`, null, null, {
            item,
            index,
            items: _vm.selectableItems(item)
          })];
        }
      };
    }), {
      key: `item.actions`,
      fn: function (_ref2) {
        var index = _ref2.index;
        return [_c('v-btn', {
          staticClass: "rounded-sm",
          attrs: {
            "fab": "",
            "small": "",
            "depressed": "",
            "color": "primary",
            "title": "Eltávolítás"
          },
          on: {
            "click": function ($event) {
              return _vm.removeItem(index);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('div', {
          staticClass: "d-flex justify-center py-4"
        }, [_c('v-btn', {
          attrs: {
            "color": "primary",
            "depressed": "",
            "disabled": _vm.uniqueValues && _vm.selectedItems.length === _vm.items.length
          },
          on: {
            "click": _vm.addItem
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" Hozzáadás ")], 1)], 1)];
      },
      proxy: true
    }], null, true)
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }